import { c as _c } from "react/compiler-runtime";
// The board filter (Michael, 2026-10-25: out of the nav, into a sheet): search, which closed statuses to show, people
// with their open counts. Opened by the board's floating pill (chips.tsx, ?filter=1); a panel kind (layouts/root.tsx):
// the Sheet on phones, a page after the nav on desktop. Every control writes the URL (lib/filter.ts).
import { useTranslation } from "react-i18next";
import { Field } from "@/components/field";
import { Initials } from "@/components/initials";
import { LinkButton } from "@/components/link-button";
import { Row } from "@/components/row";
import { SectionHead } from "@/components/section-head";
import { Segment, Segmented } from "@/components/segmented";
import { ME, NONE, toggle } from "@/lib/filter";
import { useBoardFilter, useBoardView, useParam, useSearchHits } from "@/lib/hooks";
import { useAuth, useData } from "@/store";
export function Filters() {
  const $ = _c(52);
  const {
    t
  } = useTranslation();
  const [filter, setFilter] = useBoardFilter();
  const snapshot = useData(_temp);
  const me = useAuth(_temp2);
  const board = useBoardView(filter, useSearchHits(filter.q));
  let t0;
  if ($[0] !== me?.name || $[1] !== t) {
    t0 = p => p.key === ME ? {
      key: ME,
      name: me?.name ?? p.name ?? t("filter.me"),
      label: t("filter.me"),
      n: p.n
    } : p.key === NONE ? {
      key: NONE,
      name: "—",
      label: t("filter.unassigned"),
      n: p.n
    } : {
      key: p.key,
      name: p.name ?? p.key,
      label: p.name ?? p.key,
      n: p.n
    };
    $[0] = me?.name;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const people = (board?.people ?? []).map(t0);
  const closed = (snapshot?.statuses ?? []).filter(_temp3).map(_temp4);
  const columns = useParam("columns");
  const t1 = "filters";
  const t2 = "filters";
  let t3;
  if ($[3] !== t) {
    t3 = t("filter.search");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("filter.search");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== setFilter) {
    t5 = e => setFilter(f => ({
      ...f,
      q: e.target.value
    }));
    $[7] = setFilter;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== filter.q || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <Field t="search" icon="search" type="search" enterKeyHint="search" placeholder={t3} aria-label={t4} value={filter.q} onChange={t5} />;
    $[9] = filter.q;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== columns || $[15] !== filter.project || $[16] !== t) {
    t7 = filter.project && <LinkButton data-t="columns-open" onClick={() => columns.open(filter.project)}>{t("columns.title")}</LinkButton>;
    $[14] = columns;
    $[15] = filter.project;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("filter.show");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <SectionHead action={t7}>{t8}</SectionHead>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const T0 = Segmented;
  const t10 = "show";
  let t11;
  if ($[23] !== t) {
    t11 = t("filter.show");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== filter.show || $[26] !== setFilter) {
    t12 = s_3 => <Segment key={s_3} pressed={filter.show.includes(s_3)} onClick={() => setFilter(f_0 => ({
      ...f_0,
      show: toggle(f_0.show, s_3)
    }))}>{s_3}</Segment>;
    $[25] = filter.show;
    $[26] = setFilter;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = closed.map(t12);
  let t14;
  if ($[28] !== T0 || $[29] !== t11 || $[30] !== t13) {
    t14 = <T0 t={t10} label={t11}>{t13}</T0>;
    $[28] = T0;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== filter.who.length || $[33] !== setFilter || $[34] !== t) {
    t15 = filter.who.length > 0 && <LinkButton onClick={() => setFilter(_temp5)}>{t("filter.all")}</LinkButton>;
    $[32] = filter.who.length;
    $[33] = setFilter;
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("filter.people");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <SectionHead action={t15}>{t16}</SectionHead>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const t18 = "rows";
  const t19 = "people";
  let t20;
  if ($[41] !== filter.who || $[42] !== setFilter) {
    t20 = p_0 => {
      const on = filter.who.includes(p_0.key);
      return <li key={p_0.key}><Row t="person" id={p_0.key} lead={<Initials name={p_0.name} on={on} />} label={p_0.label} count={p_0.n} aria-pressed={on} onClick={() => setFilter(f_2 => ({
          ...f_2,
          who: toggle(f_2.who, p_0.key)
        }))} /></li>;
    };
    $[41] = filter.who;
    $[42] = setFilter;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = people.map(t20);
  let t22;
  if ($[44] !== t21) {
    t22 = <ul className={t18} data-t={t19}>{t21}</ul>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t14 || $[47] !== t17 || $[48] !== t22 || $[49] !== t6 || $[50] !== t9) {
    t23 = <div className={t1} data-t={t2}>{t6}{t9}{t14}{t17}{t22}</div>;
    $[46] = t14;
    $[47] = t17;
    $[48] = t22;
    $[49] = t6;
    $[50] = t9;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
}
function _temp5(f_1) {
  return {
    ...f_1,
    who: []
  };
}
function _temp4(s_2) {
  return s_2.name;
}
function _temp3(s_1) {
  return !s_1.open;
}
function _temp2(s_0) {
  return s_0.me;
}
function _temp(s) {
  return s.snapshot;
}